<template>
  <svg
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    viewBox="0 0 168 150"
    style="enable-background: new 0 0 168 150"
    xml:space="preserve"
  >
    <g></g>
    <g></g>
    <g class="st0"></g>
    <g>
      <g>
        <g>
          <g class="st3">
            <path
              class="st5"
              d="M13.309,130.421c-1.24,0.04-1.68,0.08-2.68,0.16v-1.76c-2.359,1.6-3.84,2.439-7.039,3.879
                    c-0.68-1.44-1.279-2.4-2.359-3.68c3.079-1.16,4.959-2.12,7.639-3.879c-2.239-2.6-3.6-3.839-5.599-5.239l3.279-2.44
                    c0.64,0.52,0.64,0.52,1.279,1.04v-4.159c0.76,0.12,1.92,0.2,3.319,0.2h7.399c1.879,0,2.52-0.04,3.439-0.16
                    c0.399,1.6,0.96,2.52,2.479,4.359c1.279-1.28,1.56-1.52,2.359-2.56c0.56-0.72,0.68-0.84,0.84-1.16c0.2-0.32,0.2-0.32,0.32-0.52
                    l3.679,2.04c-0.12,0.16-0.64,0.76-1.56,1.84c-0.72,0.84-1.96,2.08-2.959,3c1.079,0.92,1.52,1.28,2.359,1.92
                    c1.72-1.56,3.199-3.28,4.159-4.839l3.68,2.08c-0.24,0.24-0.32,0.36-1.12,1.24c-1.04,1.28-2.199,2.439-3.6,3.68
                    c2.16,1.28,3.479,1.919,6.399,3.039c-0.92,1.2-1.16,1.64-2.24,3.959c-3.279-1.52-4.438-2.16-6.599-3.599v1.72
                    c-1.2-0.12-1.92-0.16-3.839-0.16v4.319h6.358c1.96,0,3-0.04,4.199-0.24v4.279c-1.239-0.16-2.399-0.24-4.199-0.24h-6.358v5.959
                    c0,0.84,0.039,0.92,0.64,1.08c0.52,0.16,1.199,0.2,2.56,0.2c2.199,0,3.159-0.2,3.6-0.76c0.359-0.48,0.6-1.8,0.72-4
                    c1.56,0.76,2.72,1.16,4.319,1.4c-0.88,6.759-1.6,7.359-9.278,7.359c-5.439,0-6.72-0.68-6.72-3.479v-7.759h-5.159
                    c-0.52,2.399-1.279,4.159-2.479,5.759c-1.999,2.64-4.398,4.239-9.318,6.159c-0.76-1.48-1.56-2.64-2.839-3.919
                    c3.719-1.04,5.639-1.959,7.398-3.56c1.399-1.24,2.239-2.52,2.84-4.439H7.51c-1.84,0-2.88,0.04-4.199,0.24V134.5
                    c1.239,0.2,2.239,0.24,4.199,0.24h5.719c0.04-0.52,0.04-0.8,0.04-1.24L13.309,130.421z M10.269,118.343
                    c-0.72,0-1.6,0.04-2.439,0.16c2.12,1.76,3.04,2.64,4.359,4.119c1.68-1.52,2.72-2.64,3.92-4.279H10.269z M26.227,126.662
                    c0.52,0,0.52,0,0.84,0c-2.84-2.32-4.6-4.16-6.799-7.239c-2.24,3.119-3.92,4.919-6.759,7.239c0.439,0,0.64,0,1.079,0H26.227z
                     M17.508,133.82c0,0.36,0,0.52,0,0.92h4.679v-4.319h-4.639L17.508,133.82z"
            />
            <path
              class="st5"
              d="M61.707,133.101c-0.96,1.16-1.319,1.52-2.919,3v8.238c3.079-0.56,4.759-0.959,8.278-1.879v4.199
                    c-2.999,0.84-3.919,1.04-8.358,1.959c-2.72,0.52-2.88,0.56-5.079,0.92c-0.96,0.16-0.96,0.16-1.88,0.28
                    c-0.8,0.16-1.56,0.32-1.92,0.4l-0.96-4.68c1.6-0.04,3-0.16,5.52-0.479v-5.479c-2.68,1.8-4.76,2.84-8.519,4.399
                    c-0.72-1.72-1.32-2.759-2.48-4.279c5.319-1.439,9.519-3.599,12.878-6.599H48.71c-1.84,0-3.32,0.08-4.68,0.24v-4.319
                    c1.2,0.2,2.279,0.24,4.64,0.24h10.958v-2.56H51.83c-2.279,0-3.239,0.04-4.399,0.16v-3.999c1.12,0.12,2.08,0.16,4.399,0.16h7.799
                    v-2.439H50.03c-2.199,0-3.399,0.04-4.479,0.2v-4.199c1.2,0.16,2.64,0.24,4.68,0.24h9.398c0-1.72-0.04-2.479-0.24-3.439h4.919
                    c-0.199,1-0.239,1.64-0.239,3.439h10.038c2.199,0,3.56-0.08,4.759-0.24v4.199c-1.08-0.16-2.319-0.2-4.479-0.2H64.068v2.439
                    h8.438c2.399,0,3.359-0.04,4.438-0.16v3.999c-1.159-0.12-2.119-0.16-4.438-0.16h-8.438v2.56h11.558c2.279,0,3.52-0.04,4.6-0.24
                    v4.319c-1.36-0.16-2.8-0.24-4.6-0.24h-9.318c0.76,1.72,1.64,3.119,3.119,4.919c2.04-1.56,3.72-3.279,4.68-4.599l3.999,2.479
                    c-0.28,0.28-0.28,0.28-0.92,0.92c-1.159,1.16-2.879,2.72-4.719,4.159c2.839,2.12,5.079,3.279,8.758,4.52
                    c-1.279,1.56-1.999,2.719-2.639,4.319c-5.439-2.359-9.079-4.999-11.918-8.479c-1.84-2.279-3.4-4.999-4.72-8.238H61.707z"
            />
            <path
              class="st5"
              d="M85.151,131.661c1-3.52,1.28-5.999,1.32-10.558l3.159,0.72c-0.08,4.359-0.44,7.679-1.28,11.158
                    L85.151,131.661z M94.629,145.379c0,2.08,0.08,3.479,0.24,4.959h-4.68c0.2-1.36,0.28-3.159,0.28-5.079v-27.675
                    c0-1.76-0.08-2.879-0.28-4.279h4.68c-0.2,1.4-0.24,2.399-0.24,4.279v3.319l2.359-0.92c1,2,1.08,2.24,2.04,5.199l-1.08,0.48
                    c1,0.08,1.8,0.12,3.359,0.12h5.919v-1.6h-4.559c-1.561,0-2.24,0.04-3.36,0.16v-3.56c1.04,0.12,1.76,0.16,3.399,0.16h4.52v-1.479
                    h-5.159c-2.119,0-2.879,0.04-3.959,0.2v-3.839c1.16,0.2,2,0.24,4.159,0.24h4.959c0-1.2-0.04-1.8-0.24-2.72h4.6
                    c-0.2,0.96-0.24,1.479-0.24,2.72h6.119c2.2,0,3-0.04,4.159-0.24v3.839c-1.159-0.16-2.159-0.2-4.079-0.2h-6.199v1.479h5.64
                    c1.72,0,2.359-0.04,3.319-0.16v3.56c-0.96-0.12-1.76-0.16-3.399-0.16h-5.56v1.6h6.999c1.92,0,2.88-0.04,3.96-0.2v3.919
                    c-1.2-0.16-2.32-0.24-3.96-0.24h-17.037c-1.96,0-2.919,0.04-4.039,0.24v-3.52l-1.24,0.56c-0.399-1.68-0.8-2.919-1.399-4.439
                    V145.379z M103.308,145.698c0,1.96,0.08,3.359,0.24,4.559h-4.6c0.16-1.32,0.2-2.239,0.2-4.559V134.18
                    c0-1.52-0.04-2.28-0.12-3.399c0.96,0.08,1.8,0.12,3.199,0.12h14.078c1.759,0,2.759-0.04,3.599-0.16
                    c-0.12,0.96-0.159,2.16-0.159,4.12v11.278c0,3.04-1.08,3.839-5.119,3.839c-0.88,0-1.641-0.04-3.6-0.16
                    c-0.24-1.72-0.4-2.399-0.92-3.839c1.64,0.24,2.919,0.36,3.919,0.36c1.28,0,1.52-0.16,1.52-0.96v-1.36h-12.237V145.698z
                     M115.545,135.86v-1.64h-12.237v1.64H115.545z M115.545,140.739v-1.64h-12.237v1.64H115.545z"
            />
            <path
              class="st5"
              d="M142.188,124.022c1.68,0,2.4-0.04,3.479-0.2v4.239c-0.76-0.12-1.279-0.12-2.239-0.16
                    c-0.439,1.919-0.64,2.68-1.319,4.439h0.479c1.439,0,2.199-0.04,3.079-0.2v4.239c-1.079-0.12-1.919-0.16-3.479-0.16h-3.119v3.2
                    h2.72c1.52,0,2.319-0.04,3.319-0.16v4.199c-1.04-0.12-1.84-0.16-3.319-0.16h-2.72v2.919c0,1.32,0.08,2.799,0.2,4.079h-4.399
                    c0.16-1.32,0.24-2.52,0.24-4.079v-2.919h-2.88c-1.52,0-2.199,0.04-3.319,0.16v-4.199c1,0.12,1.8,0.16,3.319,0.16h2.88v-3.2
                    h-3.56c-1.52,0-2.359,0.04-3.479,0.16v-4.239c1,0.16,1.64,0.2,3.479,0.2h0.439c-0.239-1.6-0.479-2.679-1.039-4.439
                    c-1.32,0-1.96,0.04-2.88,0.16v-4.239c1.04,0.16,1.88,0.2,3.479,0.2h3.6v-3.08h-2.72c-1.439,0-2.239,0.04-3.319,0.16v-4.159
                    c0.96,0.12,1.72,0.16,3.319,0.16h2.72v-0.72c0-1.12-0.08-2.479-0.24-3.04h4.319c-0.12,0.92-0.16,1.76-0.16,3.04v0.72h2.359
                    c1.6,0,2.36-0.04,3.319-0.16v4.159c-1.039-0.12-1.919-0.16-3.319-0.16h-2.359v3.08H142.188z M138.349,132.34
                    c0.52-1.359,0.88-2.759,1.2-4.439h-4.8c0.561,1.919,0.72,2.68,1,4.439H138.349z M163.705,129.501
                    c-0.2,0.52-0.279,0.76-0.479,1.76c-0.84,3.679-2.04,7.239-3.399,9.918c1.56,1.919,2.879,3,5.519,4.639
                    c-1.239,1.919-1.64,2.68-2.319,4.239c-2.319-1.84-3.68-3.12-5.439-5.199c-1.399,1.959-2.719,3.399-4.759,5.159
                    c-0.76-1.4-1.319-2.24-2.239-3.479c0.04,1.6,0.119,2.399,0.279,3.759h-4.559c0.239-1.68,0.279-2.679,0.279-4.759v-26.755
                    c0-1.439-0.08-3-0.199-4.079c1.159,0.16,2.279,0.2,3.759,0.2h9.839c1.799,0,3.039-0.08,3.719-0.2c-0.12,1.16-0.16,1.64-0.2,2.6
                    c-0.479,7.358-1.039,8.198-5.438,8.198c-1.08,0-1.8-0.04-3.6-0.2c-0.24-1.76-0.399-2.479-0.88-3.759
                    c1.6,0.28,3.239,0.48,4.119,0.48c1.24,0,1.44-0.4,1.6-3.36h-8.718v8.759h7.519c1.92,0,2.959-0.04,3.799-0.16L163.705,129.501z
                     M150.587,145.978c1.839-1.439,3.159-2.799,4.438-4.639c-1.72-2.839-2.52-4.959-3.799-10.118h-0.64V145.978z M154.867,131.221
                    c0.68,2.76,1.279,4.359,2.399,6.359c0.84-1.879,1.359-3.479,1.959-6.359H154.867z"
            />
          </g>
        </g>
        <g>
          <g>
            <path
              class="st4"
              d="M76.084,12.483L41.555,72.669c-3.49,6.083,0.914,13.663,7.927,13.644l69.387-0.19
                    c7.013-0.019,11.375-7.623,7.852-13.687L91.864,12.44C88.341,6.376,79.574,6.4,76.084,12.483z"
            />
            <path
              class="st5"
              d="M49.456,89.313c-4.364,0-8.276-2.251-10.47-6.027c-2.199-3.786-2.212-8.313-0.033-12.11L73.482,10.99
                    c0,0,0,0,0,0c2.18-3.797,6.094-6.071,10.472-6.083c0.012,0,0.023,0,0.035,0c4.363,0,8.275,2.25,10.469,6.026l34.857,59.996
                    c2.2,3.786,2.212,8.313,0.033,12.111c-2.179,3.797-6.093,6.072-10.471,6.083l-69.388,0.19
                    C49.479,89.313,49.467,89.313,49.456,89.313z M78.687,13.976L44.158,74.161c-1.1,1.916-1.094,4.2,0.017,6.11
                    c1.106,1.905,3.08,3.041,5.282,3.041c0.006,0,0.012,0,0.018,0l69.388-0.19c2.208-0.006,4.184-1.153,5.282-3.069
                    c1.1-1.916,1.093-4.2-0.017-6.11L89.27,13.947c-1.107-1.905-3.081-3.041-5.282-3.041c-0.006,0-0.012,0-0.018,0
                    C81.761,10.912,79.786,12.06,78.687,13.976z"
            />
          </g>
          <g>
            <g>
              <rect
                x="82.032"
                y="30.503"
                transform="matrix(1 -0.0027 0.0027 1 -0.1234 0.2301)"
                class="st5"
                width="4.063"
                height="29.436"
              />
              <path
                class="st5"
                d="M82.073,61.945c-0.528,0-1.035-0.209-1.41-0.582c-0.376-0.374-0.589-0.882-0.59-1.413l-0.081-29.436
                        c-0.003-1.104,0.89-2.002,1.994-2.005l4.063-0.011c0.002,0,0.004,0,0.006,0c0.528,0,1.035,0.209,1.41,0.582
                        c0.376,0.374,0.589,0.882,0.59,1.413l0.08,29.436c0.003,1.104-0.89,2.002-1.994,2.005l-4.062,0.011
                        C82.077,61.945,82.075,61.945,82.073,61.945z M83.998,32.504l0.069,25.436l0.062,0l-0.068-25.436L83.998,32.504z"
              />
            </g>
            <g>
              <rect
                x="82.099"
                y="67.698"
                transform="matrix(1 -0.0027 0.0027 1 -0.1907 0.2303)"
                class="st5"
                width="4.063"
                height="4.29"
              />
              <path
                class="st5"
                d="M82.105,73.994c-0.528,0-1.035-0.209-1.41-0.582c-0.376-0.374-0.589-0.882-0.59-1.413l-0.012-4.29
                        c-0.003-1.104,0.89-2.002,1.994-2.005l4.063-0.011c0.002,0,0.004,0,0.006,0c0.528,0,1.035,0.209,1.41,0.582
                        c0.376,0.374,0.589,0.882,0.59,1.413l0.012,4.29c0.003,1.104-0.89,2.002-1.994,2.005l-4.063,0.011
                        C82.109,73.994,82.107,73.994,82.105,73.994z M84.099,69.698v0.29l0.063,0v-0.29L84.099,69.698z"
              />
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
</template>
<script>
export default {};
</script>
<style lang="scss">
.st0 {
  display: none;
}
// .st1 {
//   display: inline;
//   fill: #d2ddf0;
// }
// .st2 {
//   display: inline;
//   fill: #1e58b5;
// }
.st3 {
  enable-background: new;
}
.st4 {
  fill: #ffffff;
}
.st5 {
  fill: #1e58b5;
}
// .st6 {
//   fill: none;
//   stroke: #1e58b5;
//   stroke-width: 6;
//   stroke-linecap: round;
//   stroke-linejoin: round;
//   stroke-miterlimit: 10;
// }
// .st7 {
//   fill: #ffffff;
//   stroke: #1e58b5;
//   stroke-width: 6;
//   stroke-linecap: round;
//   stroke-linejoin: round;
//   stroke-miterlimit: 10;
// }
// .st8 {
//   fill: #1e58b5;
//   stroke: #1e58b5;
//   stroke-width: 4;
//   stroke-linecap: round;
//   stroke-linejoin: round;
//   stroke-miterlimit: 10;
// }
// .st9 {
//   fill: none;
//   stroke: #1e58b5;
//   stroke-width: 6;
//   stroke-linejoin: round;
//   stroke-miterlimit: 10;
// }
</style>